import { axiosInstance, CustomResponseFormat } from "api/instance";

export const EXPIRATION_NOTICE_DOMAIN = "expiration-notice";

export const EXPIRATION_NOTICE_DETAIL_ENDPOINT = "detail";
export const EXPIRATION_NOTICE_SEND_ENDPOINT = "send";
export const EXPIRATION_NOTICE_SKIP_ENDPOINT = "skip";

export interface ExpirationDetailType {
  expirationDate: string;
  expiryDaysLeft: number;
}

export const expirationNoticeApi = {
  detail: (pid: number) =>
    axiosInstance.get<CustomResponseFormat<ExpirationDetailType | undefined>>(
      `${EXPIRATION_NOTICE_DOMAIN}/${EXPIRATION_NOTICE_DETAIL_ENDPOINT}`,
      { params: { pid: pid } }
    ),
  send: (pid: number) =>
    axiosInstance.post<void>(
      `${EXPIRATION_NOTICE_DOMAIN}/${EXPIRATION_NOTICE_SEND_ENDPOINT}`,
      undefined,
      { params: { pid: pid } }
    ),
  skip: (pid: number) =>
    axiosInstance.post<void>(
      `${EXPIRATION_NOTICE_DOMAIN}/${EXPIRATION_NOTICE_SKIP_ENDPOINT}`,
      undefined,
      { params: { pid: pid } }
    ),
};